/**
 * Реквизиты продавца для Terms, Refund и Privacy. Заполняет владелец (юридическое имя ИП должно совпадать
 * с данными в Paddle и Meta). Пока значения в квадратных скобках, страницы показывают их как есть.
 */
export const SELLER = {
  productName: "AI Administrator",
  legalName: "[legal name of the sole proprietor]",
  registration: "[registration number, Georgia]",
  address: "[registered address]",
  email: "[support@your-domain]",
  governingLaw: "[governing law and courts]",
} as const;

/** Пока юрист не проверил тексты, на страницах Terms, Refund и Privacy висит плашка «черновик». */
export const LEGAL_REVIEWED = false;

/** Дата последней редакции юридических текстов. */
export const LEGAL_UPDATED = "2026-10-28";
